import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { useNavigate } from "react-router-dom";
import {
  BlockHeadContent,
  BlockTitle,
  BlockBetween,
  BlockHead,
  Icon,
} from "../../components/Component";
import { Button } from "reactstrap";
import BasePaginationTable from "../../components/table/BasePaginationTable";
import moment from "moment";
import { useSelector } from "react-redux";
import { defaultParams } from "../../constants";
import { useDispatch } from "react-redux";
import { deleteEventSuccess, getListEvent } from "../../slice/events";
import { deleteEvent } from "../../api/event";
import { toast } from "react-toastify";
import DeleteConfirmationModal from "../admin/modals/DeleteConfimationModal";
import UpdateEventModal from "./modals/UpdateEventModal";
import TableActions from "../../components/table/TableActions";
import TableText from "../../components/table/TableText";

const readEn = (v) => {
  if (!v) return "";
  if (typeof v === "string") return v;
  return v.en ?? v.ar ?? "";
};
const readAr = (v) => {
  if (!v || typeof v === "string") return "";
  return v.ar ?? "";
};

function getDefaultColumns(onEditClick, onDeleteClick) {
  return [
    {
      head: <span className="sub-text">{"Title"}</span>,
      cell: (row) => (
        <TableText
          text={readEn(row.name)}
          sub={readAr(row.name)}
          maxWidth={220}
          lines={1}
        />
      ),
    },
    {
      head: <span className="sub-text">{"Description"}</span>,
      cell: (row) => (
        <TableText
          text={readEn(row.desc)}
          sub={readAr(row.desc)}
          maxWidth={320}
        />
      ),
    },

    {
      head: <span className="sub-text">{"Image"}</span>,
      cell: (row) => (
        <img
          src={readEn(row.image)}
          alt="event-img"
          width={100}
          style={{
            objectFit: "cover",
          }}
        />
      ),
    },
    {
      head: <span className="sub-text">{"Location"}</span>,
      cell: (row) => <span>{row.location}</span>,
    },
    {
      head: <span className="sub-text"></span>,
      cellClassName: "nk-tb-col-tools",
      cell: (row) => (
        <TableActions
          actions={[
            { label: "Edit", icon: "eye", onClick: () => onEditClick(row) },
            {
              label: "Delete",
              icon: "delete",
              danger: true,
              onClick: () => onDeleteClick(row),
            },
          ]}
        />
      ),
    },
  ];
}
const EventsPage = () => {
  const [smOption, setSmOption] = useState(false);
  const onDelete = (event) => {
    setEventModalVisible({ event, delete: true });
  };
  const closeModal = () => {
    setEventModalVisible({
      event: null,
      delete: false,
    });
  };
  const openModal = (event) => {
    setEventModalVisible({ event, update: true });
  };
  const [params, setParams] = useState(defaultParams);
  const dispatch = useDispatch();
  const [isEventModalVisible, setEventModalVisible] = useState({
    event: null,
    delete: false,
    update: false,
  });
  const dataTableColumns = getDefaultColumns(openModal, onDelete);
  const { list, summary, loading } = useSelector((state) => state.events);
  useEffect(() => {
    dispatch(getListEvent(params));
  }, [dispatch, params]);
  const handlePageChange = (page) => {
    setParams({
      ...params,
      page,
    });
  };
  /// func
  const onDeleteEvent = async () => {
    try {
      await deleteEvent(isEventModalVisible.event?._id);
      dispatch(deleteEventSuccess(isEventModalVisible.event));
      toast.success("Delete event successfully");
    } catch (error) {
      toast.error(error);
    }
  };
  return (
    <React.Fragment>
      <Head title="Events"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Events</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand me-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="nk-block-tools g-3">
                    <li className="nk-block-tools-opt">
                      <Button
                        className="toggle d-none d-md-inline-flex"
                        color="primary"
                        onClick={() => {
                          openModal();
                        }}
                      >
                        <Icon name="plus"></Icon>
                        <span>Add Event</span>
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <BasePaginationTable
          list={list}
          loading={loading}
          columns={dataTableColumns}
          onPageChange={handlePageChange}
          hasNextPage={summary?.hasNextPage}
          totalItems={summary?.count}
          {...params}
        />
      </Content>
      <UpdateEventModal
        event={isEventModalVisible.event}
        isOpen={isEventModalVisible.update}
        closeModal={closeModal}
      />
      <DeleteConfirmationModal
        onConfirm={onDeleteEvent}
        isOpen={isEventModalVisible.delete}
        onCloseModal={closeModal}
      />
    </React.Fragment>
  );
};

export default EventsPage;
